import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { sendContactMessage } from "../../services/portalAluno/contact/contactService";
import type { ContactFormData } from "../../@types/portalAluno";
import type { ApplicationState } from "../../store";

const useContact = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const mutation = useMutation({
    mutationFn: (form: ContactFormData) => {
      if (!auth?.idUsuario) throw new Error("Sessão de usuário inválida.");

      return sendContactMessage(
        {
          email: auth.emailUsuario ?? "",
          login: auth.lgUsuario,
          name: auth.nmUsuario ?? "Usuário do Conectado",
        },
        form
      );
    },
  });

  return { auth, ...mutation };
};

export default useContact;
